import { render, staticRenderFns } from "./MenuNode.vue?vue&type=template&id=8745d5a6"
import script from "./MenuNode.vue?vue&type=script&lang=js"
export * from "./MenuNode.vue?vue&type=script&lang=js"
import style0 from "./MenuNode.vue?vue&type=style&index=0&id=8745d5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports